export function generateVisitorId() {
    // crypto.randomUUID is not supported in some browsers/webviews.
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    return `v_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
}

export function getOrCreateVisitorId() {
    if (typeof window === "undefined") return null; 

    let visitorId = localStorage.getItem("visitorId");
    if (!visitorId) {
        visitorId = generateVisitorId();
        localStorage.setItem("visitorId", visitorId);
    }
    return visitorId;
}

export function getVisitorId() {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("visitorId") || null;
}

export function clearVisitorId() {
    if (typeof window !== "undefined") {
        localStorage.removeItem("visitorId");
    }
}


